import { CheckCircle2 } from "lucide-react";

export default function HandoffSuccess() {
    return (
        <div className="px-6 py-10 text-center" data-testid="handoff-success">
            <div className="h-12 w-12 rounded-full bg-[#E8EFE8] grid place-items-center mx-auto mb-4">
                <CheckCircle2 className="h-6 w-6 text-[#0E2A47]" />
            </div>
            <p className="font-[Outfit] text-[17px] font-semibold text-[#1A2230]">
                Sent — Dorothy and Valerie will be in touch.
            </p>
            <p className="mt-2 text-[13px] text-[#6F6B63]">
                Usually within one business day.
            </p>
        </div>
    );
}
